import React, { useEffect } from 'react'
import { Box, Divider } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { useDispatch, useSelector } from 'react-redux'

import { useSubscriptionDetails } from '../../hooks/subscriptions'
import { pushAnalyticsEvent } from '../../util/gtmUtils'
import useOnboarding from '../../hooks/onboarding'
import { isEligibleToSubscribe } from '../../util/subscriptions'
import {
  loadSubscriptionDetailsStart,
  loadSubscriptionOfferStart,
} from '../../redux/modules/subscriptions'
import { selectHomeTeamsVisible } from '../../redux/selectors/userTeamSelectors'
import HomeSubscription from './HomeSubscription'
import HomeOnboarding from './HomeOnboarding'
import HomeTeams from './HomeTeams'

const HomeSidebar = ({ showSubscription }) => {
  const dispatch = useDispatch()
  const isWebpSupported = useSelector(state => state.browser.isWebpSupported)
  const showHomeTeams = useSelector(selectHomeTeamsVisible)
  const {
    isSubscriptionEligible,
    isSubscriptionBeneficiary,
    subscriptionOffer,
    isSubscribedBefore,
    isSubscribed,
  } = useSubscriptionDetails()
  const {
    defaultStep,
    hasEmailTime,
    hasCuisineTypes,
    hasMobileApp,
    isLoadingUserProgress,
    hideOnboarding,
    isEligible: isEligibleOnboarding,
  } = useOnboarding()

  const userEligibleForSubscriptionsPromo =
    isEligibleToSubscribe(subscriptionOffer) &&
    !isSubscribedBefore &&
    !isSubscribed &&
    !isSubscriptionBeneficiary
  const showHomeSubscription = showSubscription && userEligibleForSubscriptionsPromo

  useEffect(() => {
    dispatch(loadSubscriptionOfferStart())
  }, [dispatch])

  useEffect(() => {
    if (isEligibleToSubscribe(subscriptionOffer)) {
      loadSubscriptionDetailsStart()
    }
  }, [dispatch, subscriptionOffer])

  useEffect(() => {
    if (showHomeSubscription) {
      pushAnalyticsEvent('Subscriptions', 'Promo Card - View')
    }
  }, [showHomeSubscription])

  if (isSubscriptionEligible === undefined || (isLoadingUserProgress && isEligibleOnboarding))
    return <SkeletonLoadingHomeSidebar />

  return (
    <Box marginY={4}>
      {showHomeSubscription && hideOnboarding && (
        <HomeSubscription isSubscribedBefore={isSubscribedBefore} />
      )}

      {!hideOnboarding && (
        <HomeOnboarding
          defaultStep={defaultStep}
          hasEmailTime={hasEmailTime}
          hasCuisineTypes={hasCuisineTypes}
          hasMobileApp={hasMobileApp}
        />
      )}

      {showHomeTeams && (!hideOnboarding || showHomeSubscription) && (
        <Box marginY={4}>
          <Divider />
        </Box>
      )}

      {showHomeTeams && <HomeTeams isWebpSupported={isWebpSupported} />}
    </Box>
  )
}

export const SkeletonLoadingHomeSidebar = () => (
  <Box marginTop={5}>
    <Box marginBottom={2}>
      <Skeleton height={240} variant="rect" width={200} />
    </Box>
    <Skeleton height={40} width={150} />
    <Skeleton width={210} />
    <Skeleton width={210} />
    <Skeleton height={70} width={150} />
  </Box>
)

export default HomeSidebar
